import { render, staticRenderFns } from "./bank_account.vue?vue&type=template&id=07bbe4c4&"
import script from "./bank_account.vue?vue&type=script&lang=ts&"
export * from "./bank_account.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports